import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";

import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { element } from "protractor";
import { AuthService } from "../../../auth/auth.service";
import Swal from "sweetalert2";
import { MainService } from "../../main.service";
import { debug } from "console";
@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  profileForm: FormGroup;
  submitted: boolean = false;
  isLoading: boolean = false;
  private modalRef: NgbModalRef;

  children: FormArray;
  selectedChildIndex: number = 0;
  croppedImage: any = "";
  carPic: any = "";
  imageChangedEvent: any = "";
  isUploading: boolean = true;
  allSelectedActivities = [];
  currentChildIndex = 1;
  addKid: boolean = false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  userId: any = "";
  // private modalRef: NgbModalRef;
  dropdownSettingCircle: IDropdownSettings = {
    singleSelection: false,
    idField: "_id",
    textField: "title",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 3,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  constructor(
    private fb: FormBuilder,
    private mainService: MainService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal // private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getUserDetails();
    this.initialiseForms();
    // this.getSchoolsList();
    // this.getEducationList();
    // this.getIncomeList();
    // this.getActivityList();
    // this.getEthnicityList();
    // this.getCitizenShipList();
    // this.getCountryData();
  }
  initialiseForms() {
    this.profileForm = this.fb.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      numberOfKids: [Number],
      isAutoPaymentEnabled: [false],
      // children: this.fb.array([this.createChildFormGroup()]),
    });
  }
  // createChildFormGroup(): FormGroup {
  //   return this.fb.group({
  //     firstName: ["Johny", Validators.required],
  //     lastName: ["Doe", Validators.required],
  //     age: [11, Validators.required],
  //     gender: ["Male", Validators.required],
  //   });
  // }

  // get childrenFormArray() {
  //   return this.profileForm.get("children") as FormArray;
  // }

  // selectChild(index: number) {
  //   this.selectedChildIndex = index;
  // }

  editProfile() {
    console.log(this.profileForm.value);
    console.log(this.childArray, "childArray");
  }

  ethnicityList = [];
  getEthnicityList() {
    let query = "";
    this.authService.getEthincityApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.ethnicityList = res.data.response;
          this.ethnicityList.push({
            ethnicityName: "A race or ethnicity not listed here",
            _id: "other",
          });
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  get f() {
    return this.profileForm.controls;
  }

  fileChangeEvent(event: any): void {
    this.isLoading = true;
    let file, img;
    if (
      (file = event.target.files[0]) &&
      (file.type === "image/png" || file.type === "image/jpeg")
    ) {
      img = new Image();
      this.imageChangedEvent = event;
    } else {
      Swal.fire({
        icon: "error",
        html: "Unsupported File Type. Only jpeg and png is allowed!",
      });
    }
    this.isLoading = false;
  }
  imageChangedEvent2: any;
  fileChangeEvent2(event: any, content: any, btn: any, i: any): void {
    this.isLoading = true;
    let file, img;

    if (
      (file = event.target.files[0]) &&
      (file.type === "image/png" || file.type === "image/jpeg")
    ) {
      img = new Image();
      this.imageChangedEvent2 = event;
      this.OpenModalKid(content, btn, i);
    } else {
      if (file) {
        Swal.fire({
          icon: "error",
          html: "Unsupported File Type. Only jpeg and png is allowed!",
        });
      } else {
        return;
      }
    }
    this.isLoading = false;
  }

  index: any;
  OpenModalKid(content, btn, i) {
    this.index = i;
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // console.log(this.croppedImage,'CropImage')
  }

  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  cancel(): void {
    this.croppedImage = null;
    this.imageChangedEvent = null;
    this.isUploading = false;
    setTimeout(() => {
      /** spinner ends after 1 seconds */
      this.isUploading = true;
    }, 1000);
  }
  save() {
    const blob = this.b64toBlob(this.croppedImage);
    this.imageChangedEvent = "";
    this.isLoading = true;
    this.mainService.uploadImage(blob).subscribe((res) => {
      if (res["message"] == "Success") {
        this.isLoading = false;
        setTimeout(() => {
          this.carPic = res.data.url;

          this.profileForm.controls["profilePic"].setValue(this.carPic);
        }, 1000);
      }
    });
  }
  editForm() {
    let selectedActivity = [];
    this.submitted = true;
    // if (this.profileForm.valid) {
    //selected Activity list

    let req = this.profileForm.value;
    req["kidsArray"] = this.childArray.map((child) => {
     // const { status, ...rest } = child; // destructure to exclude 'status'
      return child;
    });
    // req["isProfileBasic"] = true;
    delete req["email"];
    delete req["isProfileBasic"];

    this.isLoading = true;
    this.mainService.updateUser(req).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          setTimeout(() => {
            localStorage.setItem(
              "userData",
              JSON.stringify(res["data"]["response"])
            );
          }, 0);
          this.isLoading = false;
          this._snackBar.open(
            "User Profile Updated Successfully!!",
            "success",
            {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            }
          );
          this.router.navigate(["main/home"]);
        }
      },
      (err) => {
        this.isLoading = false;
        this._snackBar.open(err?.error.data, "error", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["error"],
        });
      }
    );
    // }
  }

  profilePic: any;
  getUserDetails() {
    this.isLoading = true;
    this.mainService.getUserDetails().subscribe(
      (res) => {
        this.isLoading = false;

        if (res["message"] == "Success") {
          let userData = res.data.response;
          this.profileForm.patchValue({
            name: userData["name"],
            email: userData["email"],
            lastName: userData["lastName"],
            firstName: userData["firstName"],
            numberOfKids: userData["numberOfKids"],

            profilePic: userData["profilePic"],
            isAutoPaymentEnabled: userData["isAutoPaymentEnabled"],
          });
          // debugger;
          this.childArray = userData["kidsArray"];
          this.profilePic = userData["profilePic"];
          // (click)="selectChild(i)"
          if (this.childArray?.length != 0) {
            this.selectChild(0);
          }
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  countryList = [];
  getCountryData() {
    let query = "";
    this.authService.getCountryApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.countryList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: "image/jpeg" });
  }
  incomeList = [];
  getIncomeList() {
    this.isLoading = true;
    let query = "";
    this.mainService.getIncomeDataApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.incomeList = res.data.response;
        } else {
          this.incomeList = [];
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  selectedActivity: any;
  onItemSelectRole(event: any) {
    console.log(this.profileForm.value);
  }
  onSelectAllRole(event: any) {}
  onItemDeSelectRole(event: any) {}
  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 46 && event.charCode <= 57;
  }
  childArray: any[] = [];
  generateChildControls() {
    const numberOfChildren = this.profileForm.controls["numberOfKids"].value;
    this.childArray = Array(numberOfChildren)
      .fill(null)
      .map(() => ({
        firstName: "",
        lastName: "",
        age: null,
        gender: "",
        profilePic: "",
      }));
    this.currentChildIndex = 1;
    // const numberOfChildren = this.profileForm.get("children").value || 0;
    // this.childArray = Array(numberOfChildren).fill(0);
  }

  get selectedChild() {
    return this.childArray[this.currentChildIndex];
  }
  hoveredIndex: any;
  onMouseEnter(index: number) {
    this.hoveredIndex = index;
  }

  onMouseLeave() {
    this.hoveredIndex = null;
  }

  selectChild(index: number) {
    this.currentChildIndex = index;
  }

  kidAdd() {
    this.addKid = true;
  }

  onContinue() {
    // Handle the final submission
    console.log("All Child Data:", this.childArray);
    // Add your logic to handle the final array
  }
  cancelChild() {
    this.addKid = false;
  }
  firstName: any;
  lastName: any;
  age: any;
  gender: any = "";
  profileImag: any = "";
  saveChild() {
    let req = {
      firstName: this.firstName,
      lastName: this.lastName,
      age: this.age,
      gender: this.gender,
      profilePic: this.profileImag,
    };
    this.mainService.addChild(req).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.addKid = false;
          this.getUserDetails();
          this._snackBar.open("Kid Added Successfully!!", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }

  closeModal() {
    this.modalRef.close();
    // this.selectedActivity = [];
    // this.allSelectedActivities = [];
    // this.selectedActivities = []
    // this.allSelectedActivities = JSON.parse(localStorage.getItem('allactivity'));
    // this.selectedActivities = JSON.parse(localStorage.getItem('activityInput'));
  }

  kidImage: any;

  save2() {
    this.closeModal();
    const blob = this.b64toBlob(this.croppedImage);
    this.isLoading = true;
    this.imageChangedEvent = null;
    this.mainService.uploadImages(blob).subscribe((res) => {
      this.isLoading = false;

      if (res["message"] === "Success") {
        this.isLoading = false;
        this.kidImage = res.data.url;
        if (this.addKid == true) {
          this.profileImag = this.kidImage;
        }
        this.childArray[this.currentChildIndex].profilePic = this.kidImage;

        // this.userForm.value.profilePic = this.storeImage;

        // console.log(this.userForm.value.profilePic, "profile pic");
      }
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  toggleAutoPay() {
    const currentValue = this.profileForm.get("isAutoPaymentEnabled")?.value;
    const newValue = !currentValue;

    this.profileForm.get("isAutoPaymentEnabled")?.setValue(newValue);

    const req = {
      isAutoPaymentEnabled: newValue,
    };

    this.mainService.updateUser(req).subscribe(
      (res) => {
        if (res["message"] === "Success") {
          setTimeout(() => {
            localStorage.setItem(
              "userData",
              JSON.stringify(res["data"]["response"])
            );
          }, 1000);
          this._snackBar.open("Auto Payment updated successfully!", "success", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        }
      },
      (err) => {
        this._snackBar.open("Failed to update Auto Payment", "error", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["error"],
        });
      }
    );
  }

  onGenderChange(value: string) {
  this.selectedChild.gender = value.toLowerCase();
}
}
